if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.hydrateDeferredImages();
        this.showActiveMedia();
      }

      /* 2026-08-04 性能：灯箱图改为打开时才赋 src。
         原因：灯箱在页面加载时是隐藏的，但 display:none 子树内的 <img> 浏览器照样下载，
         而灯箱容器宽 1220px、sizes 算出的档位远高于主图 —— 实测商品页一加载就白下
         两张 2200w（308KB + 244KB）。延迟后画质不变（打开时仍取同样的高分辨率档位）。
         幂等：赋值后移除 data- 属性，重复打开不会重复触发。 */
      hydrateDeferredImages() {
        this.querySelectorAll('img[data-defer-src], img[data-defer-srcset]').forEach((img) => {
          const srcset = img.getAttribute('data-defer-srcset');
          const src = img.getAttribute('data-defer-src');
          if (srcset) {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-defer-srcset');
          }
          if (src) {
            img.setAttribute('src', src);
            img.removeAttribute('data-defer-src');
          }
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
